export const DEFAULT_ADVISOR = {
  name: 'Cedric de Delva',
  phone: '514-233-7639',
  email: 'privacy@assureli.com',
} as const;
